import { query, where } from "firebase/firestore";
import getClientsRef from "./getClientsRef";

const getClientQueryByUID = (clientId) => {
  return query(getClientsRef(), where('UID', '==', clientId))
};

export default getClientQueryByUID;